import { copyValueToClipboard } from '@naturehouse/nh-essentials/lib/utils/copyToClipboard';
import createToast from '../../../util/toast';

export default class CopyToClipboardTextArea extends HTMLTextAreaElement {
    #successMessage: string | null = null;

    #errorMessage: string | null = null;

    public connectedCallback(): void {
        this.#successMessage = this.getAttribute('success-message');
        this.#errorMessage = this.getAttribute('error-message');

        this.addEventListener('click', this.#copy);
    }

    public disconnectedCallback(): void {
        this.removeEventListener('click', this.#copy);
    }

    readonly #copy = (event: Event): void => {
        event.preventDefault();
        event.stopPropagation();

        copyValueToClipboard(this).then(this.#renderSuccess).catch(this.#renderError);
    };

    readonly #renderSuccess = (): void => {
        if (!this.#successMessage) {
            return;
        }

        createToast(this.#successMessage);
    };

    readonly #renderError = (): void => {
        if (!this.#errorMessage) {
            return;
        }

        createToast(this.#errorMessage);
    };
}

if (!customElements.get('copy-to-clipboard-textarea')) {
    customElements.define('copy-to-clipboard-textarea', CopyToClipboardTextArea, {
        extends: 'textarea'
    });
}
